import { GetRequest, PostRequest } from "./HttpService";

export const getCommentForBlog = async (blogId) => {
  const data = await GetRequest(`/Comment/blog/${blogId}`);
  return data;
};

export const createComment = async (data) => {
  const response = await PostRequest("/Comment/add", {
    blogId: data.BlogId,
    content: data.Content,
  });

  return response.data;
};

export const deleteComment = async (id) => {
  const response = await PostRequest(`/Comment/delete/${id}`);
  return response;
};

export const checkComment = async (id) => {
  const response = await PostRequest(`/Comment/check/${id}`);
  return response;
};

export const getUnCheckComment = async () => {
  const data = await GetRequest("/Comment/unchecked");
  return data;
};

export const getUserComment = async () => {
  const data = await GetRequest("/Comment/usercomments");
  return data;
};

export const replyComment = async (data, id) => {
  const response = await PostRequest(`/Comment/${id}/reply`, {
    blogId: data.BlogId,
    content: data.Content,
  });

  return response.json();
};
